import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import ConnectedDevicesWeb from 'features/integrations/features/ConnectedDevices/index.web.jsx';
import ConnectedDevicesWidget from 'features/integrations/features/ConnectedDevices/index.web.widget';
import { selectUpdatedSelectedDevice } from 'features/integrations/state/selectors/deviceSelectors';
import { selectIntegrationFetching } from 'features/integrations/state/selectors/integrationSelectors';
import { setSelectedDevice } from 'features/integrations/state/thunks';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';

export default function ConnectedDevices({ widget = false, widgetType = '', dimensions }) {
  // Dev-only render tracking
  try {
    if (process.env.NODE_ENV === 'development') {
      require('hooks/useRenderTracker').default('ConnectedDevices');
    }
  } catch (e) {}
  const {
    data: connectedDevices = [],
    isLoading: connectedDevicesLoading,
    isError: connectedDevicesError,
  } = useGetConnectedDevicesQuery();
  const updatedSelectedDevice = useSelector(selectUpdatedSelectedDevice);
  const fetching = useSelector(selectIntegrationFetching);
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const [startTime, setStartTime] = useState(new Date().getTime() - 24 * 60 * 60 * 1000);
  const [endTime, setEndTime] = useState(new Date().getTime());
  const [showDeviceSettings, setShowDeviceSettings] = useState(false);
  const [showCurrentDevice, setShowCurrentDevice] = useState(false);
  const [init, setInit] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    if (init || connectedDevices.length === 0) return;

    //get search params
    if (params.get('device')) {
      const nodeId = parseInt(params.get('device'));
      let nodeIndex = -1;

      connectedDevices.forEach((node, index) => {
        if (nodeIndex >= 0) return;
        if (node.nodeId === nodeId) nodeIndex = index;
      });

      if (nodeIndex < 0) return;

      dispatch(setSelectedDevice({ index: nodeIndex }));
      setInit(true);
    }
  }, [connectedDevices]);

  // Only show full-page loading on initial load when we have no device data yet.
  if (fetching && connectedDevices.length === 0) {
    return <WidgetLoadingAnimation />;
  }

  if (connectedDevices.length > 0) {
  }

  if (widget) {
    return (
      <ConnectedDevicesWidget
        widgetType={widgetType}
        dimensions={dimensions}
        widget={widget}
        setShowCurrentDevice={setShowCurrentDevice}
        setShowDeviceSettings={setShowDeviceSettings}
        selectedGroup={selectedGroup}
        setSelectedGroup={setSelectedGroup}
      />
    );
  }

  // If we're not in a widget, render the full page.
  if (!widget)
    return (
      <div className="d-flex flex-column flex-fill h-100 min-h-0">
        <ConnectedDevicesWeb
          showCurrentDevice={showCurrentDevice}
          setShowCurrentDevice={setShowCurrentDevice}
          updatedSelectedDevice={updatedSelectedDevice}
          startTime={startTime}
          endTime={endTime}
          selectedGroup={selectedGroup}
          setShowDeviceSettings={setShowDeviceSettings}
          setSelectedGroup={setSelectedGroup}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          showDeviceSettings={showDeviceSettings}
        />
      </div>
    );
}
